// Dependencies.
import styled, { css } from 'styled-components'

// Libs
import {
  forScreensGreaterThanMobileWidth,
  fileFromDataURLWithName,
  colors,
} from '../../utils'

export const event_createPageStyles = css`
  padding-top: 100px;
  padding-bottom: 100px;

  .exitButton {
    z-index: 10;
    cursor: pointer;
    position: fixed;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
  }

  .titleSection {
    margin-bottom: 0px;
  }

  .buttonsSection .content {
    display: flex;
    flex-direction: column;

    & .saveButtonSection {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .saveButton,
    .cancelButton,
    .errorContainer {
      flex-grow: 0;
      flex-shrink: 0;
      margin: auto;
    }

    .saveButton,
    .errorContainer {
      margin-top: 60px;
      width: 100%;

      max-width: 493px;
    }

    .errorContainer {
      margin-top: 8px;
    }

    .cancelButton {
      margin-top: 20px;
      width: 124px;

      button {
        width: 100%;
      }
    }
  }

  /* Desktop. */
  ${forScreensGreaterThanMobileWidth(css`
    .titleSection {
      margin-bottom: 51px;
    }
  `)}
`
